<template>
  <div class="sidebar-right">
    <template v-if="!edit">
      <div class="sidebar-header">
        <h3 class="title-information">Información</h3>
        <!-- <span><i class="far fa-edit" /></span> -->
      </div>
      <div class="sidebar-content">
        <div class="content">
          <span class="label">
            Producto
          </span>
          <span class="caption" v-if="document && document.product">
            {{ document.product.name }}
          </span>
        </div>
        <div class="content">
          <span class="label">
            Tipo de producto
          </span>
          <span class="caption">
            {{ document && document.productType ? document.productType : '-' }}
          </span>
        </div>
        <div class="content">
          <span class="label">
            Régimen
          </span>
          <span class="caption" v-if="document && document.regime">
            {{ document.regime.code }}
          </span>
        </div>
        <div class="content">
          <span class="label">
            Categoría
          </span>
          <span class="caption" v-if="document && document.documentType">
            {{ $t(`documentsTemplateType.${document.documentType.code}`, systemConfiguration.lang) }}
          </span>
        </div>
        <div class="content">
          <span class="label">
            Fecha de alta
          </span>
          <span class="caption">
            {{ document ? humanDate(document.createdAt, 'DD-MMMM-YYYY', false, 'es') : '-' }}
          </span>
        </div>
        <button v-if="document && document.type" class="button is-intelligential is-small" @click="showModalPdf">Ver en PDF</button>
      </div>
    </template>
    <template v-else>
      <div class="sidebar-header">
        <div>
          <h3 class="title-information">Variables</h3>
          <p class="description">
            Usa las variables para completar tu documento.
          </p>
          <p class="description">
            Solo añádela una vez y deja que se rellene automáticamente en tu documento o plantilla.
          </p>
          <p class="description">
            Una variable se escribe entre llaves, como <label><span>&#123;&#123;</span>tuVariable.aMostrar<span>&#125;&#125;</span></label>
          </p>
          <p class="description">
            Puedes elegir las variables de nuestra lista.
          </p>
          <div class="divider"></div>
          <AccordionVariables v-for="(section, index) in sections" :key="index" class="mt-4" :section="section"/>
        </div>
      </div>
    </template>
    <pdf-viewer
      v-if="showPDF"
      titleModal="Documento en pdf"
      :cancel="showModalPdf"
      pdf="https://docs.google.com/gview?url=https://s3.us-east-1.amazonaws.com/assets.intelligential.tech/Hola-Intelligential.docx&embedded=true"
      :loading="false"
      :downloadButton="true"
      :hideCloseButton="false"
      />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '@/mixins/formats'
import AccordionVariables from './AccordionVariables.vue'

export default {
  name: 'DocumentosContractuales',
  mixins: [mixins],
  components: {
    PdfViewer: () => import('@/components/Documents/ModalPdfViewer'),
    AccordionVariables
  },
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    document: {
      type: Object || null
    }
  },
  data () {
    return {
      isLoading: false,
      sections: [
        {
          title: 'Datos del Cliente',
          variables: {
            Nombre: '{{customer.fullname}}',
            Email: '{{customer.email}}',
            Teléfono: '{{customer.phone}}'
          }
        },
        {
          title: 'Representante legal',
          variables: {
            Nombre: '{{customer.persons.fullname}}',
            Email: '{{customer.email}}',
            Teléfono: '{{customer.phone}}'
          }
        },
        {
          title: 'Obligado solidario',
          variables: {
            Nombre: '{{customer.persons.fullname}}',
            Email: '{{customer.email}}',
            Teléfono: '{{customer.phone}}'
          }
        },
        {
          title: 'Información del Contrato',
          variables: {
            ContratoID: '{{contract.contractId}}',
            'Fecha Inicio': '{{contract.startDate}}',
            Monto: '{{contrat.amount | formatMoney}}'
          }
        }
      ],
      showPDF: false
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: state => state.financialCompany.financialCompany
    })
  },
  async mounted () {
  },
  methods: {
    ...mapActions([]),
    showModalPdf () {
      this.showPDF = !this.showPDF
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-right {
  width: 250px;
  height: calc(100vh - 134px);
  background: #FFF;
  border-left: 1px solid #f6f6f6;
  padding: 1rem 0.75rem;
  overflow-x: hidden;
  overflow-y: scroll;
  .sidebar-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .title-information {
    font-size: 15px;
    font-weight: 600;
    color: #363636;
    margin-bottom: 1rem;
  }
  .sidebar-content {
    display: flex;
    flex-direction: column;
    .header {
      margin-top: 30px;
      margin-left: 15px;
      font-size: 13px;
      font-weight: 600;
      text-align: left;
      width: 86%;
    }

    .content {
      border: none;
      display: flex;
      flex-direction: column;
      margin: 0;
      padding: 12px 10px;
      text-align: left;

      .label {
        color: #94a4b7;
        font-size: 10px;
        font-weight: 500;
        line-height: 1.3;
      }

      .caption {
        color: #595959;
        font-size: 11px;
        font-weight: 500;
        line-height: 1.25;
        word-break: break-all;
      }
      .with-link {
        display: flex;
        justify-content: space-between;
        label {
          cursor: pointer;
          color: var(--primary-intelligential)
        }
      }
    }

    .content:nth-child(odd) {
      background-color: #f8f9fb;
    }
    [data-tooltip]:not([disabled]).has-tooltip-info:before {
      font-size: 11px;
      background-color: var(--blue-principal);
      border-radius: 10px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      width: 100%;
    }
    .tooltip.is-tooltip-multiline::before { white-space: pre-line }
    .button {
      margin-top: 2rem;
      background: #9c69ff !important;
    }
  }
}
.description {
  font-size: 11px;
  margin-bottom: 0.5rem;
  label {
    font-weight: 700;
  }
}
.divider {
  width: 100%;
  height: 1px;
  background: #e4e4e4;
}
.mt-4 {
  margin-top: 1rem;
}
</style>
